export default __webpack_public_path__ + "static/media/techblog.463b1286.jpg";